import SystemInternalAssessmentTab from "./systemInternalAssessment/SystemInternalAssessment";
import SystemAudits from "./systemAudits/SystemAudits";
import AuditTab from "../../../common/components/questionnaireComponents/auditTab/AuditTab";

export interface ISystemAuditTabProps {
    systemId: string;
    systemName: string;
}

function SystemAuditTab(props: ISystemAuditTabProps) {
    return <AuditTab externalContent={<SystemAudits {...props} />} internalContent={<SystemInternalAssessmentTab {...props} />} />;
}

export default SystemAuditTab;
